"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Taco = function Taco(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.269,9.613a1.408,1.408,0,0,0,0-2.057l-.807-.771c-3.7-3.534-9.124-3.418-12.971.257h0a9.011,9.011,0,0,0-.269,13.109l1.883,1.8Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.064,4.688a2.808,2.808,0,0,0-.625-3.149,3.238,3.238,0,0,0-4.425.12,3.138,3.138,0,0,0-.848,1.407,3.251,3.251,0,0,0-4.173.314A3.088,3.088,0,0,0,7.05,5.274a3.336,3.336,0,0,0-3,.854,2.9,2.9,0,0,0-.319,3.987,3.355,3.355,0,0,0-1.47.814,2.9,2.9,0,0,0-.115,4.227c.025.024.056.04.082.063A2.837,2.837,0,0,0,2.6,18.84a2.986,2.986,0,0,0,1.933.8,2.78,2.78,0,0,0,.732,2.825,3.368,3.368,0,0,0,3.459.581,1.694,1.694,0,0,0,.629-.379l.754-.716",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.66,15.029a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.66,12.029a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.91,11.279a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.91,8.279a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.66,9.029a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }));
};
Taco.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Taco.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Taco;